import Vue from 'vue';
import UJS from '@rails/ujs';
import Turbolinks from 'turbolinks';
import '../admin/public/bootstrap';
import '../application/styles/main.scss';

UJS.start();
Turbolinks.start();

// Import all images <%= image_pack_tag 'rails.png' %>
require.context('../images', true);

let vueApp;
import VideoHero from '../application/javascript/VideoHero';
import Navigation from '../application/javascript/navigation';
import Dropdown from '../application/javascript/dropdown';
import LatestResourcesSlider from '../application/javascript/LatestResourcesSlider';
import SecondaryTestimonialsSlider from '../application/javascript/SecondaryTestimonialsSlider';
import TestimonialsSlider from '../application/javascript/TestimonialsSlider';
import EmailSubscription from '../application/javascript/EmailSubscription';
import popupBox from '../application/javascript/popup-box';
import modal from '../application/javascript/Modal.vue';

//Vue components
Vue.component('navigation', Navigation);
Vue.component('dropdown', Dropdown);
Vue.component('latests-resources-slider', LatestResourcesSlider);
Vue.component('secondary-testimonials-slider', SecondaryTestimonialsSlider);
Vue.component('testimonials-slider', TestimonialsSlider);
Vue.component('video-hero', VideoHero);
Vue.component('email-subscription', EmailSubscription);
Vue.component('resources-browser', () => import('../application/javascript/resources/Browser'));
Vue.component('popup', popupBox);
Vue.component('modal', modal);

// Bootstrap the Vue root instance
document.addEventListener('turbolinks:load', () => {
  vueApp = new Vue({ el: '#js-wrapper' });
});

document.addEventListener('turbolinks:visit', () => {
  if (vueApp) vueApp.$destroy();
});
